// State related endpoints
export const StateEndpoints = (builder) => ({
  getStates: builder.query({
    query: () => ({
      url: '/common/state-list',
      method: 'GET',
    }),
    providesTags: ['State'],
  }),
});
